/**
 * DropdownLayer2Depth
 */

import Config from './Config';
import Util from './Util';

class DropdownLayer2Depth {

	private $node: any;

	private $_node: any;

	private name: string;

	private _id: string;

	private selectedCagetory: string;

	private dropdownLayer: string;

	private dropdownLayerTitle: string;

	private dropdownLayerDepth1: string;

	private dropdownLayerDepth2: string;

	private $callback: any;

	private _data: any;

	private depth1: any;

	private depth2: any;

	private textValue: string;

	private listValue: string;

	private listParentValue: string;

	constructor( $node: any, data: any, name: string = 'board' /* , className: string*/ ) {
		this.$node = $node;
		this.name = name;
		this._id = 'menu2depthList';
		this.selectedCagetory = 'selectedCategory';

		this.dropdownLayer = '.ui-dropdown-community-2depth';
		this.dropdownLayerTitle =  `${this.dropdownLayer} .select`;
		this.dropdownLayerDepth1 =  `${this.dropdownLayer} .depth1`;
		this.dropdownLayerDepth2 =  `${this.dropdownLayer} .depth2`;

		this.$callback = $.Callbacks();

		this._data = data;
		this.depth1 = [];
		this.depth2 = [];

		this.setData();

		this.$_node = jQuery( this.template( data /* , className */ ) );
		this.$node.append( this.$_node );
		this.addEvent();
	}

	public setFirst() {
		// console.log( 'first' );
	}

	public getTextValue() {
		return this.textValue;
	}

	public setKey( key: string ) {
		const list = this.set2DepthUI( key );
		jQuery( `.${this._id}` ).empty().append( list );
		this.setDepth1Select( key );
	}

	public getValue() {
		return jQuery( `.${this.selectedCagetory}` ).attr( 'data-value' );
	}

	public getNode() {
		return this.$_node;
	}

	private addChange( callback: any ) {
		this.$callback.add( callback );
	}

	private setDepth1Select( key: string ) {
		const $depth1 = jQuery( `${this.dropdownLayerDepth1}` );
		$depth1.removeClass( 'is-active' );
		jQuery( `${this.dropdownLayerDepth1}[ data-key=${key} ]` ).addClass( 'is-active' );
	}

	private selectedUI( pKey: string, pValue: string, key: string, value: string ) {
		// selected 1depth
		this.setDepth1Select( pKey );

		// selected 2depth
		jQuery( `.${this._id} [data-value=${key}]` ).addClass( 'is-active' );

		// save current text value
		this.textValue = value;

		if ( Config.isShowCategory1DepthValue ) {
			value = `${pValue} > ${value}`;
		}

		// set title's value
		jQuery( this.dropdownLayerTitle ).find( '.selectedCategory' ).text( value ).attr( 'data-value', key );
	}

	private setTextValue( value: string ) {
		let _data = Util.DataFilter.filter( this.depth2, { value });
		let _idx = 0;
		let tmpData: any = {};
		let _key = '';
		let _value = '';
		let _pKey = '';
		let _pValue = '';

		if ( !_data.length ) {
			_data = this.depth2;
		}

        if ( Config.isShowCategory2DepthAll && _data.length > 1 ) {
            _idx = 1;
        }

		tmpData = _data[ _idx ];

		if ( tmpData ) {
			_key = tmpData.key;
			_value = tmpData.value;
			_pKey = tmpData.pKey;
			_pValue = tmpData.pValue;
		}

		const list = this.set2DepthUI( tmpData.pKey );

		jQuery( `.${this._id}` ).empty().append( list );

		this.selectedUI( _pKey, _pValue, _key, _value );
	}

	private setValue( key: string ) {
		const _data = Util.DataFilter.filter( this.depth2, { key });

		if ( !_data.length ) {
			return;
		}

		const _key = _data[ 0 ].key;
		const _value = _data[ 0 ].value;
		const _pKey = _data[ 0 ].pKey;
		const _pValue = _data[ 0 ].pValue;
		const list = this.set2DepthUI( _pKey );

		jQuery( `.${this._id}` ).empty().append( list );

		this.selectedUI( _pKey, _pValue, _key, _value );
	}

	private toggleSelectLayer() {
		const $p = jQuery( this.dropdownLayer );
		if ( $p.hasClass( 'is-active' ) ) {
			$p.removeClass( 'is-active' );
		} else {
			// select메뉴가 복수일 경우 모두 제거
			jQuery( this.dropdownLayer ).removeClass( 'is-active' );
			$p.addClass( 'is-active' );
		}
	}

	private addEvent() {
		// title click
		jQuery( 'body' ).on( 'click', this.dropdownLayerTitle, ( e ) => {
			if ( jQuery( this.dropdownLayerTitle ).hasClass( 'disabled' ) ) {
				return;
			}

			this.toggleSelectLayer();
		});

		// list click
		jQuery( 'body' ).on( 'click', this.dropdownLayerDepth2, ( e ) => {
			const $eventTartget = jQuery( e.target );

			// save current text value
			this.textValue = $eventTartget.text();
			this.listValue = $eventTartget.data( 'value' );
			this.listParentValue = $eventTartget.data( 'pvalue' );

			if ( Config.isShowCategory1DepthValue ) {
				this.textValue = `${this.listParentValue} > ${this.textValue}`;
			}

			this.toggleSelectLayer();

			jQuery( this.dropdownLayerTitle ).find( '.selectedCategory' ).text( this.textValue ).attr( 'data-value', this.listValue );

			this.$callback.fire( this.listValue );
		});

		// list click
		jQuery( 'body' ).on( 'click', this.dropdownLayerDepth1, ( e ) => {
			const $eventTartget = jQuery( e.target );
			const key = $eventTartget.attr( 'data-key' );
			if ( key && key.toString() === '0' ) {
				this.$callback.fire( '0' );
			} else {
				this.setKey( key );
			}
		});

		// if document is clicked, hide modalLayer;
		jQuery( 'body' ).on( 'click' , ( evt ) => {
			const container = jQuery( this.dropdownLayer );

			if ( !container.is( evt.target ) && container.has( evt.target ).length === 0 ) {
				const $parent = jQuery( this.dropdownLayerTitle ).parent( this.dropdownLayer );
				$parent.removeClass( 'is-active' );
			}

		});
	}

	private setData() {
		if ( !this._data ) {
			return;
		}

		if ( Config.isShowCategory2DepthTotal ) {
			this.depth1.push({ key: '0', value: `${Config.L10N.all}` });
		}

		jQuery.each( this._data, ( idx, item ) => {
			this.depth1.push({ key: item.categoryId, value: item.categoryName });

			if ( Config.isShowCategory2DepthAll ) {
				this.depth2.push({ pKey: item.categoryId, pValue: item.categoryName, key: item.categoryId, value: `${Config.L10N.all}` });
			}

			jQuery.each( item.categories, ( idx2, item2 ) => {
				this.depth2.push({ pKey: item.categoryId, pValue: item.categoryName, key: item2.categoryId, value: `${item2.categoryName}` });
			});
		});
	}

	private set1DepthUI() {
		const list = Util.Tmpl.iterate({
			data: this.depth1,
			template: ( _v: any ) => `<li class="ui-dropdown-community_items depth1" data-key="${_v.key}">${_v.value}</li>`,
		});
		return list;
	}

	private set2DepthUI( id = this.depth1[ 0 ].key ) {
		const list = Util.Tmpl.iterate({
			data: Util.DataFilter.filter( this.depth2, {pKey: id }),
			template: ( _v: any ) => `<li class="ui-dropdown-community_items depth2" data-pValue="${_v.pValue}" data-value="${_v.key}">${_v.value}</li>`,
		});
		return list;
	}

	private template( _data: any /*, className = 'board-category'*/ ) {

		let depth2Key = '';
		let depth2Value = '';

		if ( this.depth2 && this.depth2[ 0 ] ) {
			depth2Key = this.depth2[ 0 ].key;
			depth2Value = this.depth2[ 0 ].value;
		}

		return `<div class="ui-dropdown-wrap board-category board-category-2depth">
				<div class="ui-dropdown ui-dropdown-community ui-dropdown-community-2depth">
					<div class="select">
						<span class="${this.selectedCagetory}" data-value="${depth2Key}">${depth2Value}</span>
						<i class="fe-icon-arrow_down"></i>
					</div>
					<div class="option option-2depth">
						<div class="option-menu option-menu-1depth">
							<ul class="option-list">
								${this.set1DepthUI()}
							</ul>
						</div>
						<div class="option-menu option-menu-2depth">
							<ul class="option-list ${this._id}">
								${this.set2DepthUI()}
							</ul>
						</div>
					</div>
				</div>
			</div>`;
	}
}

export default DropdownLayer2Depth;
